import React from 'react';
import PdpWaysToWear from '../../../../../../customercenter-ui/components/product/details/components/pdpWaystoWear/waysToWear';

const WaysToWear = (data: any) => {
  return (
    <section className="max-w-screen-9xl mx-auto px-4">
      <PdpWaysToWear data={data?.data} />
    </section>
  );
};

export default WaysToWear;
